export default "__VITE_ASSET__BfpM$mNy__"